<style scoped>
div.card.floating {
  padding-top: 1em;
  padding-bottom: 1em;
}

div.card.floating .title {
  text-align: center;
  font-weight: bold;
}

div.card.floating p {
  text-align: justify;
  padding: 0 2em;
  line-height: 1.4em;
}
div.card.floating p >>> span {
  color: var(--blue);
}

div.card.floating div.password {
  background-color: #efefef;
  padding: 1.5em 2em;
  display: flex;
  justify-content: space-between;
  gap: 1em;
}

div.card.floating div.password input,
div.card.floating div.password button {
  margin-bottom: 0px;
  border: none;
}

div.card.floating div.botones {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  padding: 1em 2em 0.5em 2em;
}
</style>
<template>
  <div class="card floating">
  <h2 class="title">{{ $t('prompts.confirmPassword') }}</h2>
  <p v-html="$t('prompts.confirmPasswordWarning')"></p>
  <div class="password">
    <input class="input input--block" type="password" :disabled="status != 0" v-model="password"
      :placeholder="$t('login.password')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    <button type="button" class="button" :class="buttonClass" @click="() => status == 0 ? checkPassword() : null">{{
      buttonText }}</button>
  </div>
  <div class="botones">
    <button :aria-label="$t('prompts.downloadRecoveryKey')" :title="$t('prompts.downloadRecoveryKey')"
      class="button button--blue" @click="downloadRecoveryKey">
      {{ $t('prompts.downloadRecoveryKey') }}
    </button>
    <button @click="logout"
    :disabled="false /*status <= 0*/"
    :aria-label="$t('buttons.exit')" class="button button--black"
      :title="$t('buttons.exit')">
      {{ $t('buttons.exit') }}
    </button>
  </div>
  <div style="display: none;">
    <qrcode-vue ref="recoveryKeyQr" :value="recoveryKeyLink" size="100" level="M"></qrcode-vue>
  </div>
</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import * as pdf from '../../api/pdf';
import * as auth from '@/utils/auth';

export default {
  name: 'check-password',
  components: {
    QrcodeVue
  },
  data: function () {
    return {
      password: '',
      userAccepts: true,
      handle: '',
      recoveryKeyLink: '',
      status: 0,
    };
  },
  computed: {
    ...mapState(['accountInfo', 'userInfo']),
    buttonText() {
      if (this.status > 0) {
        return this.$t('buttons.correct');
      }
      if (this.status < 0) {
        return this.$t('buttons.incorrect');
      }
      return this.$t('buttons.verify');
    },
    buttonClass() {
      if (this.status > 0) {
        return 'button--blue';
      }
      if (this.status < 0) {
        return 'button--red';
      }
      return 'button--black';
    },
  },
  methods: {
    ...mapMutations(['closeHovers']),
    async downloadRecoveryKey(event) {
      event.preventDefault();
      action = await ibb.getRecoveryKey();
      const recoveryKey = action.text;
      pdf.generateRecoveryKeyPdf.call(this, this.$refs['recoveryKeyQr'], this.accountInfo, this.userInfo, recoveryKey);
    },
    async checkPassword() {
      const action = await ibb.checkPassword(this.password);
      this.status = action.error.type == Module.ErrorType.E_SUCCESS.value ? 1 : -1;
      setTimeout(() => {
        if (this.status < 0) this.status = 0;
      }, 2000);
    },
    async logout() {
      await auth.logout();
      this.closeHovers();
    }
  }
};
</script>